import {
  SimpleChanges,
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  TemplateRef,
  HostListener,
  Output,
  EventEmitter,
} from "@angular/core";
import { UserService } from "@modules/auth/services";
import {
  sideNavItemsList,
  sideNavSections,
} from "@modules/navigation/data/side-nav-dashboard.data";
import { SideNavItems, SideNavSection } from "@modules/navigation/models";
import { NavigationService } from "@modules/navigation/services";
import { BehaviorSubject, Observable, Subject, Subscription, firstValueFrom } from "rxjs";
import { debounceTime, map, takeUntil, withLatestFrom, filter, finalize, take } from "rxjs/operators";
import {
  NgbOffcanvas,
  OffcanvasDismissReasons,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import { ApiRequestService } from "@common/services/api-request.service";
import { ToastService } from "@common/services/toast.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UntypedFormBuilder, FormControl, Validators } from "@angular/forms";
import { SideNavService } from "../../../navigation/services/side-nav.service"; // Adjust path as necessary
import { SecureStorageService } from "../../../../app/services/secure-storage.service";
import { PermissionsService } from "../../../../app/services/permissions.service";
import { environment } from "environments/environment";



import { NavService } from "app/services/nav.service";
import { SearchItem, NavNode } from '../../models/nav.models';

import { DataService } from "app/services/data.service";

interface MeteringPoint {
  id: string;
  name: string;
  type: 'electricity' | 'water' | 'gas';
  status: 'active' | 'inactive' | 'maintenance';
}

interface MeteringSection {
  id: string;
  name: string;
  expanded: boolean;
  points: MeteringPoint[];
}

interface MeteringFarm {
  id: string;
  name: string;
  expanded: boolean;
  sections: MeteringSection[];
}



@Component({
    selector: "sb-side-nav-search",
    templateUrl: "./side-nav-search.component.html",
    styleUrls: ["side-nav-search.component.scss"],
    standalone: false
})
export class SideNavSearchComponent implements OnInit, OnDestroy {
  readonly showDeactivatedMetersLink = false;
  // Inputs/Outputs to mirror sb-side-nav API for layout bindings
  @Input() sidenavStyle!: string;
  @Input() sideNavItems!: SideNavItems;
  @Input() reloadNav!: string;
  @Input() sideNavSections?: SideNavSection[];
  @Input() searchTerm: string = '';
  @Output() searchChanged: EventEmitter<string> = new EventEmitter<string>();
  @ViewChild("rightcanvas") rightcanvas!: TemplateRef<unknown>;
  @ViewChild("noMeteringSections") noMeteringSections!: TemplateRef<unknown>;
  @ViewChild("noMeteringPoints") noMeteringPoints!: TemplateRef<unknown>;
  @ViewChild("noDevice") noDevice!: TemplateRef<unknown>;
  private destroy$ = new Subject<void>();
  private lastExpandedFarmId: string | null = null;
  private lastExpandedSectionId: string | null = null;
  private lastExpandedPointId: string | null = null;
  
  // Data
  farms: MeteringFarm[] = [];
  filteredFarms: MeteringFarm[] = [];
  
  searchSubject = new BehaviorSubject<string>('');
  searchResults$?: Observable<SearchItem[]>;
  loading$?: Observable<boolean>;
  error$?: Observable<string | null>;
  rootNodes$?: Observable<NavNode[]>;
  rootMeta$?: Observable<{ total: number; hasMore: boolean; cursor?: string } | null>;
  searchMeta$?: Observable<{ total: number; hasMore: boolean; cursor?: string } | null>;
  
  // Selection
  selectedPointId: string | null = null;
  selectedNodeId: string | null = null;
  statsDisplay: {
    meteringFarms: number;
    meteringSections: number;
    meteringPoints: number;
    meters: number;
  } | null = null;
  // Overlay
  showSearchOverlay = false;
  // Local loading flags for specific Load More buttons
  loadingMoreFarms = false;
  loadingMoreSearch = false;

  @ViewChild('treeContainer') treeContainer?: any;
  activeLevel: string | undefined;
  deviceVersion: any;
  meteringFarm: string | undefined;
  meteringSection: string | undefined;
  meteringPoint: string | undefined;
  meteringFarmManagement: any;
  meteringSectionManagement: any;
  meteringPointManagement: any;
  deviceManagement: any;
  pmLevel: string | null;

  releaseNotes: any = [];
  pageRelease = 1;
  pageSizeRelease = 5;
  username: string = '';
  closeResult = "";
  resetSideBarMenuSubscription$: Subscription;
  company!: string | null;
  isLandis: boolean = false
  private readonly maxRestorePages = 50;

  private readCachedStatsSnapshot(): {
    meteringFarms: number;
    meteringSections: number;
    meteringPoints: number;
    meters: number;
  } | null {
    try {
      const userId = localStorage.getItem('userID') || 'anonymous';
      const raw = localStorage.getItem(`nav:stats:${userId}`);
      if (!raw) {
        return null;
      }

      const parsed = JSON.parse(raw);
      return {
        meteringFarms: Number(parsed?.meteringFarms ?? 0) || 0,
        meteringSections: Number(parsed?.meteringSections ?? 0) || 0,
        meteringPoints: Number(parsed?.meteringPoints ?? 0) || 0,
        meters: Number(parsed?.meters ?? 0) || 0,
      };
    } catch {
      return null;
    }
  }

  constructor(
    public navigationService: NavigationService,
    public userService: UserService,
    private sideNavService: SideNavService,
    private fb: UntypedFormBuilder,
    private apiRequest: ApiRequestService,
    private offcanvasService: NgbOffcanvas,
    private modalService: NgbModal,
    private toastService: ToastService,
    private router: Router,
    private changeDetectorRef: ChangeDetectorRef,
    private secureStorage:SecureStorageService,
    private navService:NavService,
    private permissionsService: PermissionsService,
    private dataService:DataService
  ) {
      this.pmLevel = localStorage.getItem('pmLevel')
        this.resetSideBarMenuSubscription$ = this.dataService.currentResetSideBarMenu.subscribe((res) => {
              if(res){
                console.log('reset called')
                this.resetSidebarState();
              }
      })

  }


  async ngOnInit() {
    this.company = localStorage.getItem('company')
    this.isLandis = this.company == 'landis' ? true : false;
    this.initializeStatsState();
    this.navService.loadStats();
    this.navService.loadRootFarms();
    this.navService.restoreFromUrl();
    void this.restoreSelectionFromStorage();
    this.initializeData();
    this.setupSearch();
    try {
      const name = await this.secureStorage.getItem('username');
      this.username = name || '';
      if (!this.username) {
        const alt = await this.secureStorage.getItem('name');
        this.username = alt || '';
      }
      if (!this.username) {
        this.userService.user$.pipe(take(1)).subscribe((u: any) => {
          const full = `${u?.firstName ?? ''} ${u?.lastName ?? ''}`.trim();
          this.username = full || u?.email || '';
          this.changeDetectorRef.detectChanges();
        });
      }
    } catch {}
    this.changeDetectorRef.detectChanges();
    // Hook up large-scale search stream and initial tree load
    this.searchResults$ = this.navService.searchResults$;
    this.loading$ = this.navService.loading$;
    this.error$ = this.navService.error$;
    this.rootNodes$ = this.navService.treeNodes$.pipe(
      map(nodes => nodes.filter(n => n.parentID === 'root'))
    );  
    this.rootMeta$ = this.navService.rootMeta$;
    this.searchMeta$ = this.navService.searchMeta$;

    // Reset sidebar nodes on route navigation changes, unless a post-form refresh is pending
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((e: any) => e && e.constructor && e.constructor.name === 'NavigationEnd')
      )
      .subscribe((e: any) => {
        const shouldRefresh = localStorage.getItem('navRefreshSections') === 'yes';
        const urlStr = (e.urlAfterRedirects || e.url || '') as string;
        const inSectionForm = urlStr.includes('/dashboard/metering/meteringSection');
        if (shouldRefresh && !inSectionForm) {
          const farmId = localStorage.getItem('navRefreshFarmId') || localStorage.getItem('meteringFarmID') || '';
          if (farmId) {
            this.navService.refreshNodeChildren(String(farmId), 'farm');
          }
          localStorage.removeItem('navRefreshSections');
          localStorage.removeItem('navRefreshFarmId');
          return; // keep current expanded state after refresh
        }
       // this.resetSidebarState();
      });

    // Sync highlight with selected meter
    this.navService.selectedMeter$
      .pipe(takeUntil(this.destroy$))
      .subscribe(id => {
        if (id) {
          this.selectedNodeId = id;
        }
      });

    // Load permissions (assumes preloaded in memory like other components)
    try {
      const perms: any = this.permissionsService.getAll();
      this.meteringFarmManagement = perms.meteringFarmManagement;
      this.meteringSectionManagement = perms.meteringSectionManagement;
      this.meteringPointManagement = perms.meteringPointManagement;
      this.deviceManagement = perms.deviceManagement;
    } catch {}

    // Watch for farm expansions that result in zero children and open modal
    this.navService.treeNodes$
      .pipe(takeUntil(this.destroy$))
      .subscribe(nodes => {
        // Farm empty check
        if (this.lastExpandedFarmId) {
          const farmNode = nodes.find(n => n.id === this.lastExpandedFarmId);
          if (farmNode && farmNode.type === 'farm' && farmNode.expanded && !farmNode.loading) {
            const count = (farmNode.children?.length || 0);
            if (count === 0) {
              //this.openNoMeteringSectionsModal();
            }
            this.lastExpandedFarmId = null;
          }
        }
        // Section empty check
        if (this.lastExpandedSectionId) {
          const sectionNode = nodes.find(n => n.id === this.lastExpandedSectionId);
          if (sectionNode && sectionNode.type === 'section' && sectionNode.expanded && !sectionNode.loading) {
            const count = (sectionNode.children?.length || 0);
            if (count === 0) {
              //this.openNoMeteringPointsModal();
            }
            this.lastExpandedSectionId = null;
          }
        }
        // Point empty check
        if (this.lastExpandedPointId) {
          const pointNode = nodes.find(n => n.id === this.lastExpandedPointId);
          if (pointNode && pointNode.type === 'point' && pointNode.expanded && !pointNode.loading) {
            const count = (pointNode.children?.length || 0);
            if (count === 0) {
              //this.openNoDeviceModal();
            }
            this.lastExpandedPointId = null;
          }
        }
      });
  }

  private initializeStatsState(): void {
    this.statsDisplay = this.navService.getStatsSnapshot() ?? this.readCachedStatsSnapshot();
    this.navService.stats$
      .pipe(takeUntil(this.destroy$))
      .subscribe((stats) => {
        if (stats) {
          this.statsDisplay = stats;
          this.changeDetectorRef.detectChanges();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.resetSideBarMenuSubscription$.unsubscribe()
  }

  ngOnChanges(changes: SimpleChanges) {
  
  }

    private initializeData(): void {
    // Data matching the image structure
    this.farms = [
      {
        id: 'farm1',
        name: 'ER Testing',
        expanded: false,
        sections: [
          {
            id: 'section1',
            name: 'Main Building',
            expanded: false,
            points: [
              { id: 'point1', name: 'Main Electrical Panel', type: 'electricity', status: 'active' },
              { id: 'point2', name: 'HVAC Gas Supply', type: 'gas', status: 'active' },
              { id: 'point3', name: 'Water Supply', type: 'water', status: 'active' }
            ]
          }
        ]
      },
      {
        id: 'farm2',
        name: 'SK Silv Villa (PT)',
        expanded: false,
        sections: [
          {
            id: 'section2',
            name: 'Main Facility',
            expanded: false,
            points: [
              { id: 'point4', name: 'Electrical System', type: 'electricity', status: 'active' },
              { id: 'point5', name: 'Water Management', type: 'water', status: 'active' }
            ]
          }
        ]
      },
      {
        id: 'farm3',
        name: 'KFC Mabilo',
        expanded: true,
        sections: [
          {
            id: 'section3',
            name: 'Main Restaurant',
            expanded: true,
            points: [
              { id: 'point6', name: 'Kitchen Equipment', type: 'electricity', status: 'active' },
              { id: 'point7', name: 'Gas Line', type: 'gas', status: 'active' },
              { id: 'point8', name: 'Water Supply', type: 'water', status: 'active' }
            ]
          }
        ]
      },
      {
        id: 'farm4',
        name: 'KFC Silverton Village',
        expanded: true,
        sections: [
          {
            id: 'section4',
            name: 'Restaurant Building',
            expanded: true,
            points: [
              { id: 'point9', name: 'KFC Silverton Village (PT)', type: 'electricity', status: 'active' },
              { id: 'point10', name: 'Silverton Village - Gas', type: 'gas', status: 'active' },
              { id: 'point11', name: 'Silverton Village Water', type: 'water', status: 'active' }
            ]
          }
        ]
      }
    ];
    
    this.filteredFarms = [...this.farms];

    console.log(this.filteredFarms , ' filtered farms')
  }

    private setupSearch(): void {
    this.searchSubject
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(300)
      )
      .subscribe(term => {
        this.filterData(term);
        const trimmed = (term || '').trim();
        // If empty: perform reset/clear
        if (trimmed.length === 0) {
          this.navService.setSearchMode(false);
          this.navService.clearSearch();
          this.showSearchOverlay = false;
          return;
        }
        // If 1–2 chars: do nothing
        if (trimmed.length < 3) {
          return;
        }
        // If 3+ chars: perform search
        this.navService.setSearchMode(true);
        this.navService.clearSearch();
        this.navService.searchMeters({ query: trimmed, limit: 20 }).subscribe(res => {
          // Replace tree with filtered hierarchy
          this.navService.showFilteredHierarchy(res.data.data as any);
        });
        this.showSearchOverlay = false;
      });
  }

  onSearchChange(value: string): void {
    // Always use the latest event value (covers paste reliably)
    this.searchTerm = value ?? '';
    // Reset root meta so UI doesn't show stale root pagination state during new searches
    this.navService.resetRootMeta();
    this.searchSubject.next(this.searchTerm);
    //this.searchChanged.emit(this.searchTerm);
  }

  onSearchSubmit(): void {
    // Trigger the same search pipeline explicitly (debounced)
    this.navService.resetRootMeta();
    this.searchSubject.next((this.searchTerm || ''));
    //this.searchChanged.emit(this.searchTerm);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.navService.resetRootMeta();
    this.searchSubject.next('');
    //this.searchChanged.emit(this.searchTerm);
  }

    private filterData(term: string): void {
    if (!term || term.length < 3) {
      this.filteredFarms = [...this.farms];
      return;
    }
    
    const lowerTerm = term.toLowerCase();
    this.filteredFarms = this.farms.map(farm => {
      const farmMatch = farm.name.toLowerCase().includes(lowerTerm);
      
      const filteredSections = farm.sections.map(section => {
        const sectionMatch = section.name.toLowerCase().includes(lowerTerm);
        
        const filteredPoints = section.points.filter(point => 
          point.name.toLowerCase().includes(lowerTerm)
        );
        
        // If section or any of its points match, include the section
        if (sectionMatch || filteredPoints.length > 0) {
          return {
            ...section,
            points: filteredPoints,
            expanded: true // Auto-expand matching sections
          };
        }
        return null;
      }).filter(Boolean) as MeteringSection[];
      
      // If farm or any of its sections match, include the farm
      if (farmMatch || filteredSections.length > 0) {
        return {
          ...farm,
          sections: filteredSections,
          expanded: true // Auto-expand matching farms
        };
      }
      return null;
    }).filter(Boolean) as MeteringFarm[];
  }

    toggleNode(node: MeteringFarm | MeteringSection): void {
    node.expanded = !node.expanded;
  }
  
  selectPoint(point: MeteringPoint): void {
    this.selectedPointId = point.id;
    // Emit selection event or navigate to point details
    console.log('Selected point:', point);
  }

  onResultSelect(meterId: string): void {
    this.selectedNodeId = meterId;
    this.navService.getMeterPath(meterId).subscribe();
    this.navService.selectMeter(meterId);
    this.closeOverlay();
  }


    // Service-driven tree helpers
  getChildren(node: NavNode): NavNode[] {
    // console.log(node , 'node ')
   return node.children || [];
  }

  isActive(node: NavNode): boolean {
    return String(this.selectedNodeId) === String(node.id);
  }

  // Compute a compact viewport height for meter lists to avoid large gaps when few meters are visible
  getViewportHeight(node: NavNode): number {
    const itemSize = 38; // must match cdk itemSize
    const maxHeight = 260;
    const count = (node.children?.length || 0);
    const desired = Math.max(itemSize, Math.min(count * itemSize, maxHeight));
    return desired;
  }

   toggleDynamic(node: NavNode): void {
    this.selectedNodeId = String(node.id);

    console.log(node , 'node')
    const levelName = node.name
    const levelID = node.id 
    const levelType = node.type
    const deviceType = node.deviceType
    const meterType = node.meterType
    const deviceVersion = node.deviceVersion

    let activeLevel = levelType == 'farm' ? 'meteringFarm' : levelType == 'section' ? 'meteringSection' :  levelType == 'point' ? 'meteringPoint' : 'device'
   
    localStorage.setItem("levelID", levelID);
    localStorage.setItem("activeLevel", activeLevel);
    localStorage.setItem("meteringPointStatement", "no");

    if (activeLevel == "meteringFarm") {
      localStorage.setItem("meteringFarm", levelName);
    } else if (activeLevel == "meteringSection") {
      localStorage.setItem("meteringSection", levelName);
    } else if (activeLevel == "meteringPoint") {
      setTimeout(() => {
        localStorage.setItem("meteringPoint", levelName);
      }, 2000);
    }

    if(node.deviceVersion){
    localStorage.setItem("deviceVersion", node.deviceVersion);
    }

    if(node.isActive){
      localStorage.setItem('deviceActivationStatus' , node.isActive)
    }
    this.activeLevel = activeLevel;
    this.deviceVersion = node.deviceVersion;

    if (activeLevel == "meteringFarm") {
      //this.getAccountHierachy(levelID)
      if (localStorage.getItem("meteringFarmID") != levelID) {
        localStorage.setItem("showReporting", "yes");
        localStorage.setItem("meteringFarm", levelName);
        localStorage.setItem("meteringFarmID", levelID);
      }
      this.meteringFarm = levelName;
      this.navigateToDetailView("meteringFarm");
    }else if (activeLevel == "meteringSection") {
      localStorage.removeItem("meteringPointID");
      localStorage.setItem("showReporting", "yes");
      localStorage.setItem("meteringSectionID", levelID);
      this.meteringSection = levelName;
      this.navigateToDetailView("meteringSection");
      localStorage.setItem("meteringSection", levelName);
      localStorage.setItem('farmMeteringSection', levelName)
    } else if (activeLevel == "meteringPoint") {
      localStorage.removeItem("deviceID");
      localStorage.setItem("showReporting", "yes");
      localStorage.setItem("meteringPointID", levelID);
      localStorage.setItem("meteringPointStatement", "yes");
      this.meteringPoint = levelName;  
      this.navigateToDetailView("meteringPoint");
    }else{
       this.getSupoportedDevices(deviceType)
      localStorage.setItem("deviceType", deviceType);
      localStorage.setItem("meterType", meterType);
      if (meterType == "temp") {
        localStorage.setItem("unit", "°C");
      }
      localStorage.setItem("deviceID", levelID);
      localStorage.setItem("deviceVersion", deviceVersion);
      localStorage.setItem("device", levelName);

      if (localStorage.getItem("active") != "dashboard") {
        this.router.navigateByUrl("/dashboard/" + activeLevel);
        localStorage.setItem("active", "dashboard");
      } else {
        this.router.navigateByUrl("/dashboard/metering");
        setTimeout(() => {
          this.router.navigateByUrl("/dashboard/" + activeLevel);
        }, 500);
      }
    }



    if (levelType === 'meter') {
      this.navService.selectMeter(levelID);
      return;
    }
    if (node.expanded) {
      this.navService.collapseNode(levelID);
    } else {
      if (levelType === 'farm') {
        // Remember which farm we are expanding; used to trigger modal if empty
        this.lastExpandedFarmId = levelID;
        this.meteringFarm = levelName;
      }
      if (levelType === 'section') {
        this.lastExpandedSectionId = levelID;
        this.meteringSection = levelName;
      }
      if (levelType === 'point') {
        this.lastExpandedPointId = levelID;
        this.meteringPoint = levelName;
      }
      this.navService.expandNode(levelID,levelType as 'farm' | 'section' | 'point');
    }
  }

  private navigateToDetailView(activeLevel: "meteringFarm" | "meteringSection" | "meteringPoint") {
    const target =
      activeLevel === "meteringFarm"
        ? "/dashboard/metering-farm-details"
        : activeLevel === "meteringSection"
        ? "/dashboard/metering-section-details"
        : "/dashboard/metering-point-details";

    if (this.router.url === target) {
      this.router
        .navigateByUrl("/dashboard", { skipLocationChange: true })
        .then(() => this.router.navigateByUrl(target));
      return;
    }

    this.router.navigateByUrl(target);
  }

  loadMore(node: NavNode): void {
      console.log(node)
    if (node.type !== 'meter') {
      this.navService.loadMoreChildren(node.id, node.type as 'farm' | 'section' | 'point');
    }
  }


  trackByNodeId(index: number, node: NavNode): string {
    return node.id;
  }


   openOverlay(): void {
    if ((this.searchTerm || '').trim().length >= 3) {
      this.showSearchOverlay = true;
    }
  }
  
  closeOverlay(): void {
    this.showSearchOverlay = false;
  }

  private async restoreSelectionFromStorage(): Promise<void> {
    const activeLevel = localStorage.getItem('activeLevel');
    if (activeLevel !== 'meteringFarm' && activeLevel !== 'meteringSection' && activeLevel !== 'meteringPoint') {
      return;
    }

    const pmLevel = (localStorage.getItem('pmLevel') || '').toString();
    const farmId = localStorage.getItem('meteringFarmID') || '';
    const sectionId = localStorage.getItem('meteringSectionID') || '';
    const pointId = localStorage.getItem('meteringPointID') || '';

    const activeId =
      activeLevel === 'meteringFarm'
        ? farmId
        : activeLevel === 'meteringSection'
        ? sectionId
        : pointId;

    if (activeId) {
      this.selectedNodeId = activeId;
    }

    if (pmLevel === '1') {
      if (farmId) {
        const farmNode = await this.ensureRootNodeLoaded(farmId);
        if (farmNode) {
          this.navService.expandNode(farmNode.id, 'farm');
          await this.waitForLoadingIdle();
        }
      }

      if (sectionId && (activeLevel === 'meteringSection' || activeLevel === 'meteringPoint')) {
        const sectionNode = await this.ensureChildNodeLoaded(farmId, 'farm', sectionId);
        if (sectionNode) {
          this.navService.expandNode(sectionNode.id, 'section');
          await this.waitForLoadingIdle();
          if (pointId && activeLevel === 'meteringPoint') {
            const pointNode = await this.ensureChildNodeLoaded(sectionNode.id, 'section', pointId);
            if (pointNode) {
              this.navService.expandNode(pointNode.id, 'point');
              await this.waitForLoadingIdle();
            }
          }
        }
      }
      return;
    }

    if (pmLevel === '2') {
      if (sectionId) {
        const sectionNode = await this.ensureRootNodeLoaded(sectionId);
        if (sectionNode) {
          this.navService.expandNode(sectionNode.id, 'section');
          await this.waitForLoadingIdle();
          if (pointId && activeLevel === 'meteringPoint') {
            const pointNode = await this.ensureChildNodeLoaded(sectionNode.id, 'section', pointId);
            if (pointNode) {
              this.navService.expandNode(pointNode.id, 'point');
              await this.waitForLoadingIdle();
            }
          }
        }
      }
      return;
    }

    if (pmLevel === '3') {
      if (pointId) {
        const pointNode = await this.ensureRootNodeLoaded(pointId);
        if (pointNode) {
          this.navService.expandNode(pointNode.id, 'point');
          await this.waitForLoadingIdle();
        }
      }
    }
  }

  private async ensureRootNodeLoaded(nodeId: string): Promise<NavNode | null> {
    await this.waitForRootReady();
    for (let i = 0; i < this.maxRestorePages; i += 1) {
      await this.waitForLoadingIdle();
      const node = await this.getNodeSnapshot(nodeId);
      if (node) {
        return node;
      }
      const meta = await firstValueFrom(this.navService.rootMeta$.pipe(take(1)));
      if (!meta) {
        await this.waitForRootReady();
        continue;
      }
      if (!meta?.hasMore) {
        return null;
      }
      this.navService.loadMoreRootFarms();
      await this.waitForLoadingIdle();
    }
    return null;
  }

  private async ensureChildNodeLoaded(parentId: string, parentType: 'farm' | 'section' | 'point', targetId: string): Promise<NavNode | null> {
    if (!parentId) {
      return null;
    }
    for (let i = 0; i < this.maxRestorePages; i += 1) {
      await this.waitForLoadingIdle();
      const node = await this.getNodeSnapshot(targetId);
      if (node) {
        return node;
      }
      const parentNode = await this.getNodeSnapshot(parentId);
      if (!parentNode || !parentNode.hasMore) {
        return null;
      }
      this.navService.loadMoreChildren(parentNode.id, parentType);
      await this.waitForLoadingIdle();
    }
    return null;
  }

  private async getNodeSnapshot(nodeId: string): Promise<NavNode | null> {
    const node = await firstValueFrom(
      this.navService.treeNodes$.pipe(
        map(nodes => nodes.find(n => String(n.id) === nodeId)),
        take(1)
      )
    );
    return node || null;
  }

  private async waitForLoadingIdle(): Promise<void> {
    await firstValueFrom(this.navService.loading$.pipe(filter(v => v === false), take(1)));
  }

  private async waitForRootReady(): Promise<void> {
    await Promise.race([
      firstValueFrom(this.navService.rootMeta$.pipe(filter(meta => !!meta), take(1))),
      firstValueFrom(
        this.navService.treeNodes$.pipe(
          map(nodes => nodes.some(n => n.parentID === 'root')),
          filter(Boolean),
          take(1)
        )
      )
    ]);
  }
  
  getPointIcon(type: string): string {
    switch (type) {
      case 'electricity':
        return 'bi bi-lightning';
      case 'water':
        return 'bi bi-droplet';
      case 'gas':
        return 'bi bi-fire';
      default:
        return 'bi bi-geo-alt';
    }
  }
  
  expandAll(): void {
    console.log(this.farms)
    this.farms.forEach(farm => {
      farm.expanded = true;
      farm.sections.forEach(section => {
        section.expanded = true;
      });
    });
  }
  
  collapseAll(): void {
    this.farms.forEach(farm => {
      farm.expanded = false;
      farm.sections.forEach(section => {
        section.expanded = false;
      });
    });
  }

  private openNoMeteringSectionsModal(): void {
    try {
      this.modalService.open(this.noMeteringSections).result.then(
        (result) => {
          if (result === 'addMeteringSection') {
            localStorage.setItem('meteringSectionAction', 'add_metering_section');
            this.router.navigateByUrl('/dashboard/metering/meteringSection');
          }
          if (result === 'editMeteringFarm') {
            const defaultOptions = { autohide: true, delay: 5000 } as any;
            if (
              this.meteringFarmManagement === 'viewer' ||
              this.meteringFarmManagement === 'no-access'
            ) {
              const activeLevel = `Metering Farm ${localStorage.getItem('meteringFarm')}`;
              this.toastService.show(
                'Edit Warning',
                `You do not have permissions to edit \n${activeLevel}`,
                { headerClasses: 'bg-warning text-light', ...defaultOptions }
              );
              return;
            }
            this.router.navigateByUrl('/dashboard/metering');
            localStorage.setItem('meteringFarmAction', 'update_metering_farm');
            setTimeout(() => {
              this.router.navigateByUrl('/dashboard/metering/meteringFarmForm');
            }, 500);
          }
        },
        () => {}
      );
    } catch (e) {
      // No-op: ensure UI continues even if modal fails silently
    }
  }

  private resetSidebarState(): void {
    try {
      this.navService.setSearchMode(false);
      this.navService.resetRootMeta();
      this.navService.clearSearch();
      this.showSearchOverlay = false;
      this.searchTerm = '';
      this.selectedNodeId = null;
      this.lastExpandedFarmId = null;
      this.lastExpandedSectionId = null;
      this.lastExpandedPointId = null;
    } catch {}
  }

    private openNoMeteringPointsModal(): void {
    try {
    const defaultOptions = {
      autohide: true,
      delay: 5000,
    };
      this.modalService.open(this.noMeteringPoints).result.then(
         (result) => {
              if (result === "add") {
                this.router.navigateByUrl("/dashboard/metering");
                localStorage.setItem(
                  "meteringPointAction",
                  "add_metering_point"
                );
                setTimeout(() => {
                  this.router.navigateByUrl(
                    "/dashboard/metering/meteringPoint"
                  );
                }, 500);
                //window.location.assign("/dashboard/metering/meteringPoint")
              }
              if (result === "editMeteringSection") {
                if (
                  this.meteringSectionManagement == "viewer" ||
                  this.meteringSectionManagement == "no-access"
                ) {
                  let activeLevel = ("Metering Section " +
                    localStorage.getItem("meteringSection")) as string;
                  this.toastService.show(
                    "Edit Warning",
                    "You do not have permissions to edit \n" + activeLevel,
                    {
                      headerClasses: "bg-warning text-light",
                      ...defaultOptions,
                    }
                  );
                } else {
                  this.router.navigateByUrl("/dashboard/metering");
                  localStorage.setItem(
                    "meteringSectionAction",
                    "update_metering_section"
                  );
                  setTimeout(() => {
                    this.router.navigateByUrl(
                      "/dashboard/metering/meteringSection"
                    );
                  }, 500);
                  //window.location.assign("/dashboard/metering/meteringSection")
                }
              }
            },
            (reason) => {}
      );
    } catch (e) {
      // No-op: ensure UI continues even if modal fails silently
    }
  }


    private openNoDeviceModal(): void {
    try {
    const defaultOptions = {
      autohide: true,
      delay: 5000,
    };
      this.modalService.open(this.noDevice).result.then(
       (result) => {
              if (result === "add") {
                this.router.navigateByUrl("/dashboard/metering");

                localStorage.setItem("deviceAction", "add");
                setTimeout(() => {
                  this.router.navigateByUrl("/dashboard/metering/deviceSelect");
                }, 500);
              }
              if (result === "editMeteringPoint") {
                if (
                  this.meteringPointManagement == "viewer" ||
                  this.meteringPointManagement == "no-access"
                ) {
                  let activeLevel = ("Metering Point " +
                    localStorage.getItem("meteringPoint")) as string;
                  this.toastService.show(
                    "Edit Warning",
                    "You do not have permissions to edit \n" + activeLevel,
                    {
                      headerClasses: "bg-warning text-light",
                      ...defaultOptions,
                    }
                  );
                } else {
                  this.router.navigateByUrl("/dashboard/metering");
                  localStorage.setItem(
                    "meteringPointAction",
                    "update_metering_point"
                  );
                  setTimeout(() => {
                    this.router.navigateByUrl(
                      "/dashboard/metering/meteringPoint"
                    );
                  }, 500);
                  //window.location.assign("/dashboard/metering/meteringPoint")
                }
              }
            },
            (reason) => {}
      );
    } catch (e) {
      // No-op: ensure UI continues even if modal fails silently
    }
  }

  loadMoreFarms(){
    // set local flag and wait until NavService loading flips back
    this.loadingMoreFarms = true;
    this.navService.loadMoreRootFarms();
    // Turn off when NavService releases loading
    this.navService.loading$
      .pipe(
        filter(v => v === false),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.loadingMoreFarms = false;
        this.scrollTreeToBottomSoon();
      });
  }

  loadMoreSearch(){
    this.loadingMoreSearch = true;
    this.navService
      .loadMoreSearch({ query: this.searchTerm, limit: 20 })
      .pipe(
        withLatestFrom(this.navService.searchResults$),
        finalize(() => (this.loadingMoreSearch = false))
      )
      .subscribe(([res, all]: any) => {
        this.navService.showFilteredHierarchy(all as any);
        this.scrollTreeToBottomSoon();
      });
  }

  private scrollTreeToBottomSoon(): void {
    setTimeout(() => {
      const el = this.treeContainer?.nativeElement as HTMLElement;
      if (!el) return;
      el.scrollTop = el.scrollHeight;
    }, 0);
  }

    getSupoportedDevices(deviceType:any) {
    let body = {
        payload: {
            platform: "utilities",
            installationTypeID: "all",
        },
    };

    this.apiRequest.apiRequest("utilities/supported_device_types/", "supported_device_types.json", body)
      .subscribe((res) => {
        if (res.success) {
        const devices: any[] = Array.isArray(res?.data?.deviceTypes) ? res.data.deviceTypes : [];
        const filteredDevice = devices.find((item:any) => item?.deviceType == deviceType);
        const requiresModem = filteredDevice?.requiresModem ?? 'no';
        localStorage.setItem("requiresModem", requiresModem);
        }   
    });
}


 viewModems(node:any) {
  console.log(node , 'node modems')
    const levelID = node.id 
    const levelType = node.type
    let activeLevel = levelType == 'farm' ? 'meteringFarm' : levelType == 'section' ? 'meteringSection' :  levelType == 'point' ? 'meteringPoint' : 'device'

    localStorage.setItem("activeLevel", activeLevel);
    localStorage.setItem("meteringPointStatement", "no");
    localStorage.setItem("modems", levelID);
    localStorage.removeItem("meteringPointID");
    localStorage.setItem("showReporting", "yes");
    localStorage.setItem("meteringSectionID", levelID);
    localStorage.removeItem("deviceID");
    localStorage.removeItem("device");
    localStorage.setItem("meteringPointStatement", "no");

    this.activeLevel = activeLevel;

    this.router.navigateByUrl("/dashboard");

    setTimeout(() => {
      this.router.navigateByUrl("/dashboard/metering/modems");
    }, 500);

  }

  goToWalletDashboard( activeLevel: string, levelID: string, levelName: string, walletReady?: boolean ) {

    console.log(activeLevel , levelID , levelName)

    localStorage.setItem("activeLevel", activeLevel);
    localStorage.setItem("meteringPointID", levelID);
    localStorage.setItem("walletMeteringPointID", levelID);
    const readyFlag = typeof walletReady === "boolean" ? walletReady : false;
    localStorage.setItem("walletReady", String(readyFlag));

    localStorage.removeItem("deviceID");
    localStorage.removeItem("device");

    this.meteringPoint = levelName;
    this.activeLevel = activeLevel;

    //if(localStorage.getItem("active") == "dashboard"){
    if (localStorage.getItem("meteringPoint") != levelName) {
      this.router.navigateByUrl("/dashboard");
    }
    localStorage.setItem("meteringPoint", levelName);

    setTimeout(() => {
      this.router.navigateByUrl("/dashboard/wallet-dashboard");
    }, 500);
    //}
    
  }

  private async resolveMeteringHierarchyFromPoint(pointID: string): Promise<{ sectionID?: string; farmID?: string }> {
    const nodes = await firstValueFrom(this.navService.treeNodes$.pipe(take(1)));
    const pointNode = nodes.find((n) => String(n.id) === String(pointID) && n.type === 'point');
    if (!pointNode) {
      return {};
    }

    const parentNode = nodes.find((n) => String(n.id) === String(pointNode.parentID));
    if (!parentNode) {
      return {};
    }

    if (parentNode.type === 'section') {
      const grandParentNode = nodes.find((n) => String(n.id) === String(parentNode.parentID));
      if (grandParentNode && grandParentNode.type === 'farm') {
        return { sectionID: parentNode.id, farmID: grandParentNode.id };
      }
      return { sectionID: parentNode.id };
    }

    if (parentNode.type === 'farm') {
      return { farmID: parentNode.id };
    }

    return {};
  }

  async goToDeactivatedMeters(
    pointNode: any,
    meteringSectionID?: string,
    meteringFarmID?: string
  ) {
    const levelID = String(pointNode?.id ?? '');
    const levelName = String(pointNode?.name ?? '');
    if (!levelID) {
      return;
    }

    localStorage.setItem("active", "diagnostics");
    localStorage.setItem("activeLevel", "meteringPoint");
    localStorage.setItem("deactivatedDevices", "y");
    localStorage.setItem("deactivatedMetersFromSidebar", "y");
    localStorage.removeItem("offlineDevices");
    localStorage.removeItem("devicesWithAlerts");

    localStorage.setItem("meteringPointID", levelID);
    localStorage.setItem("meteringPoint", levelName);

    const resolvedHierarchy = await this.resolveMeteringHierarchyFromPoint(levelID);
    const effectiveSectionID = meteringSectionID || resolvedHierarchy.sectionID;
    const effectiveFarmID = meteringFarmID || resolvedHierarchy.farmID;

    if (effectiveSectionID) {
      localStorage.setItem("meteringSectionID", effectiveSectionID);
    } else {
      localStorage.removeItem("meteringSectionID");
    }
    if (effectiveFarmID) {
      localStorage.setItem("meteringFarmID", effectiveFarmID);
    } else {
      localStorage.removeItem("meteringFarmID");
    }

    localStorage.removeItem("deviceID");
    localStorage.removeItem("device");

    const targetRoute = "/dashboard/diagnostics";
    const currentUrl = this.router.url || '';
    if (currentUrl.startsWith(targetRoute)) {
      this.router.navigate([], {
        queryParams: { dm: Date.now() },
        queryParamsHandling: "merge",
      });
      return;
    }
    this.router.navigateByUrl(targetRoute);
  }


   viewMeteringPointStatement(
    activeLevel: string,
    levelID: string,
    levelName: string,
    node:any
  ) {
    const meteringPointName = node?.name ?? levelName;
    const statementRoute = "/dashboard/meteringPoint";

    localStorage.setItem("activeLevel", activeLevel);
    localStorage.setItem("meteringPointStatement", "no");
    localStorage.setItem("statement", levelID);
    localStorage.setItem("credit", levelID);
    localStorage.setItem("meteringPointID", levelID);

    localStorage.removeItem("deviceID");
    localStorage.removeItem("device");

    localStorage.setItem("showReporting", "yes");
    localStorage.setItem("meteringPointStatement", "yes");

    this.meteringPoint = meteringPointName;
    this.activeLevel = activeLevel;

    localStorage.setItem("meteringPoint", meteringPointName);

    const goToStatement = () => this.router.navigateByUrl(statementRoute);
    const reloadStatement = () =>
      this.router
        .navigateByUrl("/dashboard", { skipLocationChange: true })
        .then(() => goToStatement());

    setTimeout(() => {
      if (this.router.url === statementRoute) {
        reloadStatement();
      } else {
        goToStatement();
      }
    }, 200);
  }

  
  loadReleaseCanvas() {
    const releaseNotesUrl = (environment as typeof environment & { RELEASE_NOTES_URL?: string }).RELEASE_NOTES_URL;
    if (releaseNotesUrl) {
      window.open(releaseNotesUrl, "_blank", "noopener,noreferrer");
      return;
    }

    let body = {
      payload: {
        userID: parseInt(localStorage.getItem("userID") as string),
      },
    };

    // this.openRightCanvas()

    this.apiRequest
      .apiRequest("common/jira/release_notes/", "release_notes.json", body)
      .subscribe(
        (res) => {
          const defaultOptions = {
            autohide: true,
            delay: 5000,
          };

          console.log(res);

          if (res.success) {
            var newArr: any = [];
            let notes = JSON.parse(res.data);
            console.log(notes);
            for (var j = 0; j < notes.issues.length; j++) {
              let title = notes.issues[j].fields.summary;
              let issuetype = notes.issues[j].fields.issuetype.name;
              let description = "";
              if (notes.issues[j].fields.description != null)
                for (
                  var i = 0;
                  i < notes.issues[j].fields.description.content.length;
                  i++
                ) {
                  description +=
                    notes.issues[j].fields.description.content[i].content[0]
                      .text + "<br />";
                }
              let created = new Date(
                notes.issues[j].fields.created
              ).toLocaleDateString("zh-Hans-CN");
              newArr.push({
                title: title,
                issuetype: issuetype,
                description: description,
                created: created,
              });
            }
            this.releaseNotes = newArr;

            console.log(this.releaseNotes);
            this.openRightCanvas();
          } else {
            this.toastService.show("Release Notes", "No release notes found", {
              headerClasses: "bg-warning text-light",
              ...defaultOptions,
            });
          }
          this.changeDetectorRef.detectChanges();
        },
        (error: any) => {
          const defaultOptions = {
            autohide: true,
            delay: 5000,
          };

          console.log(error);
          let message = "";
          for (var i = 0; i < error.error.data.length; i++) {
            message += error.error.data[i] + "\n";
          }
          this.toastService.show("Device Search", error.error.data, {
            headerClasses: "bg-danger text-light",
            ...defaultOptions,
          });
        }
      );
  }

    openRightCanvas() {
    this.offcanvasService
      .open(this.rightcanvas, {
        ariaLabelledBy: "offcanvas-basic-title",
        position: "end",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === OffcanvasDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === OffcanvasDismissReasons.BACKDROP_CLICK) {
      return "by clicking on the backdrop";
    } else {
      return `with: ${reason}`;
    }
  }



}
